// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__24Uzu","xl":"styles_xl__17HEE"};